import { SimpleTooltip } from '@g17eco/molecules/simple-tooltip';
import { TableDraggableColumn, TableDraggableRows } from '@g17eco/molecules/table-draggable-rows';
import { MergedValueListOption } from '@g17eco/types/initiativeUniversalTracker';
import { Button } from 'reactstrap';

interface Props {
  options: MergedValueListOption[];
  updateOptions: (newOptions: MergedValueListOption[]) => void;
}

const draggableColumns: TableDraggableColumn[] = [
  {
    header: 'Option title',
  },
  {
    header: '',
    className: 'text-right',
  },
];

export const ValueListTable = ({ options, updateOptions }: Props) => {
  if (!options.length) {
    return <p>No options found</p>;
  }

  const toggleVisibility = (optionCode: string) => {
    const newOptions = options.map((option) => ({
      ...option,
      hidden: option.code === optionCode ? !option.hidden : option.hidden,
    }));

    updateOptions(newOptions);
  };

  const handleReorder = (codes: string[]) => {
    const newOptions = codes
      .map((code) => options.find((o) => o.code === code))
      .filter(Boolean) as MergedValueListOption[];

    updateOptions(newOptions);
  };

  const draggableRows = options.map(({ code, name, hidden }) => ({
    id: code,
    cols: [
      <div key={'name'} className='text-truncate' style={{ maxWidth: '600px' }}>
        <SimpleTooltip text={name}>{name}</SimpleTooltip>
      </div>,
      <div key={'action'} className='d-flex align-items-center justify-content-end'>
        <Button color='link-secondary' size='sm' onClick={() => toggleVisibility(code)}>
          {hidden ? (
            <span className='text-ThemeWarningDark'>
              <i className='fal fa-eye-slash me-2' />
              Hidden
            </span>
          ) : (
            <>
              <i className='fal fa-eye me-2' />
              Visible
            </>
          )}
        </Button>
      </div>,
    ],
  }));

  return (
    <TableDraggableRows
      classes={{ wrapper: 'light-theme mt-3' }}
      columns={draggableColumns}
      data={draggableRows ?? []}
      handleUpdate={handleReorder}
    />
  );
};
